/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Pressable, Icon } from '@components/atoms'
import { FullModalLayout } from '@components/molecules'
import { AdminEditMenu } from '@components/systems'
import { mono, boShared } from '@components/systems/backoffice/backoffice.tokens'

import { useAppDispatch, adminActions } from '@redux/index'

/** 새 메뉴 — 타입(폴더/오브젝트) 두 칸은 대등한 고스트, 선택 = ink 채움 */
const CreateMenuPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// state
	const [menuType, setMenuType] = React.useState<'dir' | 'object'>('dir')

	const onCloseClick = React.useCallback(() => {
		reduxDispatch(adminActions.EDIT_MENU_MODE('update'))
	}, [])

	const onTypeClick = React.useCallback((aType: 'dir' | 'object') => {
		setMenuType(aType)
		reduxDispatch(adminActions.EDIT_MENU_MODE(`create-${aType}`))
		reduxDispatch(adminActions.TRIGGER_CREATE_MENU_PAGE(true))
	}, [])

	return (
		<View css={style}>
			<FullModalLayout
				title="새 메뉴 추가"
				onCloseClick={onCloseClick}
				titleStyle={{ marginBottom: '1rem' }}
			>
				<View className="menuTypeSelectOuter">
					<span className="boLabel menuTypeLabel">타입 선택</span>

					<View className="menuTypeSelectView">
						<Pressable
							className={`menuTypeButton ${menuType === 'dir' ? 'selected' : ''}`}
							onClick={() => onTypeClick('dir')}
							aria-pressed={menuType === 'dir'}
						>
							<Icon name="folder-outline" className="menuTypeIcon" />
							<span className="menuTypeTitle">폴더</span>
							<Icon name="check" className="menuTypeCheck" />
						</Pressable>

						<Pressable
							className={`menuTypeButton ${menuType === 'object' ? 'selected' : ''}`}
							onClick={() => onTypeClick('object')}
							aria-pressed={menuType === 'object'}
						>
							<Icon name="application-brackets-outline" className="menuTypeIcon" />
							<span className="menuTypeTitle">오브젝트</span>
							<Icon name="check" className="menuTypeCheck" />
						</Pressable>
					</View>
				</View>

				<AdminEditMenu />
			</FullModalLayout>
		</View>
	)
}

export default CreateMenuPage

const style = css({
	...boShared,

	'.menuTypeSelectOuter': {
		marginBottom: 32,

		'.menuTypeLabel': { display: 'block', marginBottom: 12 },

		'.menuTypeSelectView': {
			display: 'grid',
			gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
			gap: 12,

			'.menuTypeButton': {
				display: 'flex',
				alignItems: 'center',
				gap: 10,
				width: '100%',
				height: 48,
				padding: '0 16px',
				background: 'transparent',
				border: `1px solid ${mono.lineSoft}`,
				borderRadius: 2,
				color: mono.dim,
				fontSize: 13,
				fontWeight: 500,
				transition:
					'color 200ms ease-out, background-color 200ms ease-out, border-color 200ms ease-out',

				'.menuTypeIcon': { fontSize: 18, color: 'inherit' },
				'.menuTypeTitle': { flex: 1, textAlign: 'left' },
				'.menuTypeCheck': { fontSize: 16, color: 'inherit', opacity: 0 },

				'&:hover': { borderColor: mono.ink, color: mono.ink },

				'&.selected': {
					background: mono.ink,
					borderColor: mono.ink,
					color: '#FFFFFF',
					'.menuTypeCheck': { opacity: 1 },
				},
			},
		},
	},
})
